import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Dropdown } from 'primereact/components/dropdown/Dropdown';

export default class extends Component {

  constructor(props) {
    super(props);

    this.state = {
      touched: false,
      options: props.options || [],
      value: props.meta.initial
    };
  }

  /**
  * Dropdown dynamic options initialization. Based on the provided 'loadOptions' method which should return a promise with array type result.
  */
  componentDidMount() {
    this._isMounted = true;

    const { loadOptions } = this.props;

    if (typeof loadOptions === 'function') {
      loadOptions()
        .then(options => {
          if (this._isMounted) {
            this.setState({ options });
          }
        });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getOptionValue(option) {
    const { keyField } = this.props;
    return option[keyField || 'value'];
  }

  render() {
    const { input, label, required, disableEmptyValue, onOptionSelected,
      meta: { error }, disabled, filter, cacheOptions } = this.props;

    const showError = this.state.touched && error;

    const { options } = (cacheOptions === false) ? this.props : this.state;

    const dropdownOptions = (disableEmptyValue ? [] : [{ value: null, label: ' ' }])
      .concat(options)
      .map(option => {
        const optionValue = this.getOptionValue(option);
        return optionValue !== undefined ? { ...option, value: optionValue } : option;
      });

    const onChange = ({ value }) => {

      if (value === null || value === undefined) {
        this.setState({ value: null, touched: true });
        input.onChange(null);

      } else {
        this.setState({ value, touched: true });
        input.onChange(value);
      }

      typeof onOptionSelected === 'function' && onOptionSelected(value);
    };

    return (
      <div className="input-field input-dropdown">
        {label && <label>{label}</label>}{required && <span> *</span>}
        <br />
        <Dropdown className={classNames({ 'input-error': showError })} onChange={onChange}
                  value={input.value} options={dropdownOptions} disabled={disabled}
          autoWidth={false} filter={filter || false} />
        {
          showError && (
            <Fragment>
              <div className="input-field-error"><FormattedMessage id={error} /></div>
            </Fragment>
          )
        }
      </div>
    );
  }
}
